import React, {useMemo} from 'react'

import {Tag} from '@vio/atlas/Tag'
import {BrandMessage} from '@vio/core/src/brand/types'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import {VioTagSavingType} from '@vio/core/src/tag/types'

import {Price} from '../../search/Price'

interface Props {
  /** The main message to be displayed */
  message: BrandMessage
  /** Value to be displayed as percentage saved. Will only display if larger than 0. */
  savingPercentage?: number
  /** Value to be displayed as percentage saved. Will only display if larger than 0. */
  savingPrice?: number
  /** Price currency code */
  currencyCode?: string
  /** Saving type to show */
  savingType?: VioTagSavingType
  /** Vio deal tag data id */
  dataId?: string
}

export const VioDealTag = ({
  message,
  savingPercentage,
  savingPrice = 0,
  currencyCode,
  savingType = 'percentage',
  dataId = 'privateDealTag'
}: Props) => {
  const hasSavings = Boolean(savingPercentage && savingPercentage > 0)

  const annotation = useMemo(() => {
    if (hasSavings) {
      if (savingType === 'number') {
        return (
          <Price noStyle value={-1 * savingPrice} currency={currencyCode} />
        )
      }
      return <span dir="ltr">-{savingPercentage}%</span>
    }
    return undefined
  }, [hasSavings, savingType, savingPercentage, currencyCode, savingPrice])

  return (
    <div data-id={dataId}>
      <Tag variant="brand" annotation={annotation}>
        <FormattedMessageWrapper {...message} />
      </Tag>
    </div>
  )
}
